import { Project } from '../types';

export const hivePowerUpTracker: Project = {
  id: 'hive-power-up-tracker',
  title: 'Hive Power-Up Tracker',
  description: 'Real-time monitoring and analysis of HIVE Power-Ups.',
  longDescription: 'This tool provides a clean interface to track Power-Up transactions on the Hive blockchain using hafSQL. It features flexible time ranges (1h to 30d) and advanced filtering options for whale movements (>100k HIVE) and account-specific staking. Built with performance in mind, it includes paginated results, memory management, and visual spikes identification via a density plot.',
  image: 'https://images.hive.blog/0x0/https://files.peakd.com/file/peakd-hive/louis88/23xUkzJDRJtKgHVVhLQi1yo2Rhs2dkzbfy3npDyu8KmQ3JJmvAiLobAo9dd99YfVRsJEC.png',
  tags: ['Hive', 'Blockchain', 'Tools', 'Analytics', 'Vercel'],
  link: 'https://power-up-tracker.vercel.app',
  github: 'https://github.com/louis-88/HafSQL-Power-Up-Tracker', 
  announcementUrl: 'https://peakd.com/hive-139531/@louis88/introducing-vestcore-a-tool-to-see-and-filter-hive-power-ups',
  featured: true
};